<template>
  <div>
    <v-card class="mt-4">
      <v-toolbar
        class="primary h5 text-white position-relative"
        id="plus-feature-table"
      >
        {{ $t(item.title) }}
      </v-toolbar>

      <v-card-text
        class="pa-4 locked-card-wrapper position-relative"
        :style="{ minHeight: isLocked ? '350px' : 'auto' }"
      >
        <v-simple-table class="table-compact">
          <template v-slot:default>
            <thead>
              <th class="" v-for="(head, i) in item.data.header" :key="i">
                {{ head }}
              </th>
            </thead>
            <tbody v-if="item.data.body.length > 0">
              <tr v-for="(data, index) in item.data.body" :key="index">
                <td class="max-w-250px" v-for="(el, j) in data" :key="j">
                  <template v-if="(el + '').length < 60">{{ el }}</template>
                  <template v-else>
                    <b-button
                      v-b-toggle.collapse-2
                      variant="outline-secondary"
                      class="m-1"
                      >{{ $t("show_data") }}</b-button
                    >

                    <b-collapse id="collapse-2">
                      {{ el }}
                    </b-collapse>
                  </template>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr class="h-75px">
                <td
                  :colspan="item?.data?.header?.length"
                  class="text-center pt-4"
                >
                  <span class="second-text">{{ $t("no_data") }}</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <transition name="fade-overlay">
          <div v-if="isLocked" class="locked-overlay">
            <div class="locked-overlay__backdrop"></div>
            <div class="locked-overlay__content">
              <div class="locked-overlay__icon-ring">
                <v-icon size="36" color="white">mdi-lock-outline</v-icon>
              </div>
              <h3 class="locked-overlay__title">
                {{ $t("plus_feature_overlay_title") }}
              </h3>
              <p
                class="locked-overlay__description"
                v-html="$t('plus_feature_overlay_description')"
              ></p>
              <v-btn
                color="#6C63FF"
                dark
                depressed
                large
                class="locked-overlay__cta"
                @click="handleSubscribeClick"
              >
                <v-icon left small>mdi-star-four-points</v-icon>
                {{ $t("subscribe_to_unlock") }}
              </v-btn>
            </div>
          </div>
        </transition>
      </v-card-text>
    </v-card>

    <!--    <div-->
    <!--      class="text-content my-2 ps-4"-->
    <!--      v-if="-->
    <!--        isClient &&-->
    <!--        Boolean(item?.is_plus_feature) &&-->
    <!--        !Boolean(item?.is_subscribed)-->
    <!--      "-->
    <!--    >-->
    <!--      <p class="font-weight-bolder text-dark-65">-->
    <!--        This feature is exclusive to IQ Plus subscribers-->
    <!--      </p>-->
    <!--    </div>-->

    <SubscriptionPopup
      v-if="isLocked"
      ref="subscriptionPopup"
      @showSuccessModal="showSuccessModal"
    />
    <SuccessModal ref="successModal" />
  </div>
</template>

<script>
import SubscriptionPopup from "@/own/components/IqfPlus/SubscriptionPopup.vue";
import SuccessModal from "@/own/components/IqfPlus/SuccessModal.vue";

export default {
  name: "PopUpTable",
  props: ["item", "updateDetailsData"],
  components: { SuccessModal, SubscriptionPopup },
  computed: {
    isClient: function () {
      return this.$store.getters.isClient;
    },
    isLocked() {
      // return true;
      if (this.item.title.toLowerCase().includes("call history")) {
        return Boolean(this.item?.is_plus_feature) && !this.item?.is_subscribed;
      }
      return false;
    },
  },
  methods: {
    showSuccessModal() {
      this.$refs.successModal.toggleModal();
      this.updateData();
    },
    handleSubscribeClick() {
      this.$refs.subscriptionPopup.toggleModal();
    },
    updateData() {
      this.updateDetailsData(true, false);
    },
  },
};
</script>

<style scoped>
.plus-tooltip .tooltip-inner {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%) !important;
  color: white;
  border-radius: 12px;
  padding: 1.5rem;
  max-width: 620px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.text-content p {
  margin: 0;
  font-size: 1.08rem;
  line-height: 1.4;
  text-align: start;
}

.locked-card-wrapper {
  position: relative;
}

/* ── Overlay layer ── */
.locked-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
  overflow: hidden;
}

.locked-overlay__backdrop {
  position: absolute;
  inset: 0;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  background: rgba(255, 255, 255, 0.35);
}

/* ── Centered content block ── */
.locked-overlay__content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 380px;
  padding: 36px 32px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(108, 99, 255, 0.08);
  border: 1px solid rgba(108, 99, 255, 0.12);
}

/* ── Lock icon ring ── */
.locked-overlay__icon-ring {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6c63ff 0%, #8b83ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  box-shadow: 0 4px 16px rgba(108, 99, 255, 0.3);
}

/* ── Typography ── */
.locked-overlay__title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 8px 0;
  letter-spacing: -0.01em;
}

.locked-overlay__description {
  font-size: 0.875rem;
  line-height: 1.6;
  color: #5a5a7a;
  margin: 0 0 24px 0;
}

.locked-overlay__description strong {
  color: #6c63ff;
  font-weight: 600;
}

/* ── CTA button ── */
.locked-overlay__cta {
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.9rem !important;
  letter-spacing: 0.02em !important;
  border-radius: 10px !important;
  padding: 0 28px !important;
  box-shadow: 0 4px 14px rgba(108, 99, 255, 0.35) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
}

.locked-overlay__cta:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(108, 99, 255, 0.45) !important;
}

/* ── Fade transition ── */
.fade-overlay-enter-active,
.fade-overlay-leave-active {
  transition: opacity 0.3s ease;
}

.fade-overlay-enter,
.fade-overlay-leave-to {
  opacity: 0;
}

/* ── Responsive adjustments ── */
@media (max-width: 600px) {
  .locked-overlay__content {
    max-width: 90%;
    padding: 28px 20px;
  }

  .locked-overlay__title {
    font-size: 1.1rem;
  }

  .locked-overlay__description {
    font-size: 0.8125rem;
  }

  .locked-overlay__icon-ring {
    width: 52px;
    height: 52px;
  }

  .locked-overlay__icon-ring .v-icon {
    font-size: 28px !important;
  }
}
</style>
